<template>
  <v-card>
    <v-card-title>
      New Stock Taking Record
      <v-spacer></v-spacer>
      <v-btn
        @click="
          step = 1;
          $emit('closed');
        "
        color="red lighten-5 red--text"
        rounded
        depressed
        small
        >Close
        <v-icon color="red" small>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-stepper v-model="step" elevation="0" class="pa-0">
        <v-stepper-items>
          <v-stepper-content step="1" class="ma-0">
            <v-row>
              <v-col cols="12" sm="4" class="mx-auto">
                <v-alert prominent color="warning" text type="warning">
                  <h1>Note:</h1>
                  <p>
                    During the period of stock taking, make sure to stop all
                    activities that involve selling or stocking your inventory
                    for accurate record taking.
                  </p>
                </v-alert>
                <v-form ref="recordForm" class="mt-4">
                  <v-textarea
                    v-model="description"
                    :rules="$store.state.requiredRule"
                    label="Descriptions"
                    auto-grow
                    outlined
                    color="orange"
                    placeholder="Describe this record"
                  ></v-textarea>
                </v-form>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="orange"
                    dark
                    rounded
                    depressed
                    x-large
                    :loading="loading"
                    @click="saveRecord"
                    class="ml-auto pl-4 pr-4"
                    >Continue
                    <v-icon dark>mdi-arrow-right</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-stepper-content>
          <v-stepper-content step="2">
            <stock-taking-item-details-component
              v-if="record"
              :item="record"
              @updated="(item) => (record = item)"
              @deleted="
                $emit('closed');
                $emit('deleted');
              "
            ></stock-taking-item-details-component>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card-text>
  </v-card>
</template>

<script>
import StockTakingItemDetailsComponent from "./StockTakingItemDetailsComponent.vue";

export default {
  name: "NewStockTakingComponent",
  components: { StockTakingItemDetailsComponent },
  emits: ["closed", "deleted"],
  data() {
    return {
      step: 1,
      description: "",
      loading: false,
      record: null,
    };
  },
  methods: {
    saveRecord() {
      if (this.$refs.recordForm.validate()) {
        this.loading = true;

        const data = {
          description: this.description,
        };

        axios
          .post("/api/stock-taking", data)
          .then((res) => {
            this.loading = false;

            this.record = res.data;

            this.step = 2;
          })
          .catch((error) => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style scoped></style>
